import React from 'react'
import { Button } from '../../../../components/Button/Button'
import { DEVELOPER_DOCS_URL } from '../../constants'
import './BuildWithZocksBanner.scss'

interface BuildWithZocksBannerProps {
  onAddNewApp: () => void
}

export const BuildWithZocksBanner: React.FC<BuildWithZocksBannerProps> = ({ onAddNewApp }) => {
  // Banner temporarily hidden — will be re-enabled later
  return (
    <div className='build-with-zocks-banner d-flex align-items-center justify-content-between py-4'>
      <div>
        <h5 className='mb-1 fw-bold'>Build your own app</h5>
        <p className='mb-0 zocks-text-gray-600'>
          Build a private app to connect your own tools and workflows to Zocks.{' '}
          <a href={DEVELOPER_DOCS_URL} target='_blank' rel='noopener noreferrer' className='text-decoration-underline zocks-text-gray-900'>
            Developer docs
          </a>
        </p>
      </div>
      <Button variant='primaryLinkButton' className='d-flex align-items-center gap-1 text-nowrap text-decoration-none' onClick={onAddNewApp}>
        <i className='bi bi-plus-circle' />
        Add new app
      </Button>
    </div>
  )
}
